import React from "react";
import { IconProps } from "./IconProps";

const MapPinIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10 4.81818C9.3707 4.81818 8.75552 5.00479 8.23228 5.35441C7.70903 5.70404 7.30121 6.20097 7.06038 6.78237C6.81956 7.36377 6.75655 8.00353 6.87932 8.62074C7.00209 9.23795 7.30513 9.8049 7.75011 10.2499C8.1951 10.6949 8.76205 10.9979 9.37926 11.1207C9.99647 11.2435 10.6362 11.1804 11.2176 10.9396C11.799 10.6988 12.296 10.291 12.6456 9.76772C12.9952 9.24448 13.1818 8.6293 13.1818 8C13.1818 7.15613 12.8466 6.34682 12.2499 5.75011C11.6532 5.15341 10.8439 4.81818 10 4.81818ZM10 9.90909C9.62242 9.90909 9.25331 9.79712 8.93937 9.58735C8.62542 9.37758 8.38072 9.07942 8.23623 8.73058C8.09174 8.38174 8.05393 7.99788 8.12759 7.62755C8.20125 7.25723 8.38308 6.91706 8.65007 6.65007C8.91706 6.38308 9.25723 6.20125 9.62755 6.12759C9.99788 6.05393 10.3817 6.09174 10.7306 6.23623C11.0794 6.38072 11.3776 6.62542 11.5874 6.93937C11.7971 7.25331 11.9091 7.62242 11.9091 8C11.9091 8.50632 11.708 8.99191 11.3499 9.34993C10.9919 9.70796 10.5063 9.90909 10 9.90909ZM10 1C8.14413 1.00211 6.36488 1.74028 5.05258 3.05258C3.74028 4.36488 3.00211 6.14413 3 8C3 10.4977 4.1542 13.145 6.34091 15.6562C7.32347 16.791 8.42934 17.8128 9.63807 18.7028C9.74507 18.7778 9.87254 18.818 10.0032 18.818C10.1338 18.818 10.2613 18.7778 10.3683 18.7028C11.5748 17.8125 12.6785 16.7907 13.6591 15.6562C15.8426 13.145 17 10.4977 17 8C16.9979 6.14413 16.2597 4.36488 14.9474 3.05258C13.6351 1.74028 11.8559 1.00211 10 1ZM10 17.3864C8.68511 16.3523 4.27273 12.554 4.27273 8C4.27273 6.48103 4.87613 5.02428 5.95021 3.95021C7.02428 2.87613 8.48103 2.27273 10 2.27273C11.519 2.27273 12.9757 2.87613 14.0498 3.95021C15.1239 5.02428 15.7273 6.48103 15.7273 8C15.7273 12.5524 11.3149 16.3523 10 17.3864Z"
            fill={color}
          />
        </svg>
      );
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.7 18.8C9.79 18.86 9.9 18.89 10 18.89V18.88C10.11 18.88 10.21 18.85 10.3 18.79C10.57 18.6 17 14.03 17 8C17 6.13 16.27 4.37 14.95 3.05C13.63 1.73 11.87 1 10 1C8.13 1 6.37 1.74 5.05 3.06C3.73 4.38 3 6.14 3 8.01C3 14.04 9.43 18.61 9.7 18.8ZM5.78 3.79C6.90764 2.66236 8.40373 2.04259 9.99003 2.04001C11.5862 2.04259 13.0724 2.66236 14.2 3.79C15.33 4.92 15.95 6.42 15.95 8.01C15.95 12.8 11.23 16.77 9.99 17.73C8.75 16.77 4.03 12.81 4.03 8.01C4.03 6.41 4.65 4.92 5.78 3.79ZM6.89001 8.00001C6.89001 9.71001 8.28001 11.11 10 11.11C11.71 11.11 13.11 9.71001 13.11 8.00001C13.11 6.29001 11.71 4.89001 10 4.89001C8.29001 4.89001 6.89001 6.29001 6.89001 8.00001ZM7.93001 8.00001C7.93001 6.86001 8.86001 5.93001 10 5.93001C11.14 5.93001 12.07 6.86001 12.07 8.00001C12.07 9.14001 11.14 10.07 10 10.07C8.86001 10.07 7.93001 9.14001 7.93001 8.00001Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default MapPinIcon;
